<app-upsell-card
  htmlTitle="Control oil and inflammation <strong>with Zinc</strong>"
  question="We strongly recommend including Zinc tablets with your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Zinc helps regulate oil production and calm inflammation from within. It's a smart addition to your acne routine,
    especially when combined with prescription treatments.
  </p>
  <p class="mb-4">
    <strong>Daily: balance + calm</strong><br />
    Helps reduce excess oil that can clog pores and trigger breakouts.<br />
    Supports the body's natural inflammatory response to keep acne flare-ups under control.
  </p>
  <p class="mb-4">
    <strong>Long-term: maintain results</strong><br />
    Complements doxycycline and topical treatments by supporting skin healing and overall skin health.<br />
    May help reduce the frequency and severity of future breakouts.
  </p>
  <div class="mb-4">
    <strong>Why add it?</strong><br />
    <ul>
      <li>Helps control oil and shine</li>
      <li>Supports clearer skin from the inside</li>
      <li>Gentle and suitable for long-term use</li>
      <li>Works well alongside prescription acne treatments</li>
    </ul>
  </div>
</app-upsell-card>
